import { DICT_DEFAULT_RESOURCE_TEXT, SCHEDULER_RESPONSE_ERROR_TRANSLATION_KEY } from "../utils/constants";
import SectionComponent from "./section.component";

export default class ConfirmationComponent extends SectionComponent {

    #resourcesService;

    constructor() {
        super();
    }

    init(resourcesService) {
        this.#resourcesService = resourcesService;
    }

    showAcknowledgement(responseCode, appointmentDate, appointmentTime) {
        let response; 
        if (responseCode == 0) {
            response = this.#resourcesService.getResource("SELFSCHEDULER_SUCCESS_RESPONSE", DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_SUCCESS_RESPONSE);
            response = response.replace("{0}", `<span class="body2">${appointmentDate}</span>`);
            response = response.replace("{1}", `<span class="body2">${appointmentTime}</span>`);
        } else {
            const responseResourceKey = SCHEDULER_RESPONSE_ERROR_TRANSLATION_KEY[responseCode];   
            response = this.#resourcesService.getResource(responseResourceKey, DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_ERROR_RESPONSE);
        }
        this.setContent(`<div class="v24-acknowledgement">${response}</div>`);
    }

    showLocationConfirmation(location) {
        const address = document.createElement("address");
        const locationLabelResource = this.#resourcesService.getResource(`SELFSCHEDULER_LOCATION_CONFIRMATION_LABEL`, DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_LOCATION_CONFIRMATION_LABEL);
        address.id = "v24LocationConfirmationDiv";
        address.className = "v24-location-confirmation-container";
        const addressLine2Row = (location.addressLine2 !== undefined && location.addressLine2 !== null && location.addressLine2.length > 0) ? location.addressLine2 + '<br/>': '';
        address.innerHTML = ` <div class="v24-location-confirmation-row"><label>${locationLabelResource}</label><div>${location.name}</br> ${location.address}</br>${addressLine2Row} ${location.postcode}</div></div>
                                  ${this.#createEmailHTML(location.contactEmail)}
                                  ${this.#createPhoneHTML(location.phone)}
                                `;

        super.appendChild(address);
    }

    #createPhoneHTML(phoneNumber) {
        if (phoneNumber.length > 0) {
            return ` <div><a href="tel:${phoneNumber}">${phoneNumber}</a></div>`;
        }
        else return "";
    }

    #createEmailHTML(emailAddress) {
        if (emailAddress.length > 0) {
            return `<div><a href="mailto:${emailAddress}">${emailAddress}</a></div>`;
        }
        else return "";
    }
}